import React, { useEffect, useState } from 'react'
import { Card, Col, Container } from 'reactstrap'
import { Link } from 'react-router-dom'
import axios from 'axios'
import baseUrl from '../../../../helpers/baseurl'

export const ExcelReport = ( props ) => {

  console.log('Props passed:', props)

  const apiClient = axios.create({
    baseURL: baseUrl,
    headers: {
      'Accept':'*/*',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': true,
      'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
      'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
    },
  })

  useEffect(
    async () => {
      const response = await apiClient.get(`lab-requests/exportToExcel?limit=20&page=0`)
    }
  , [])

  return(
    <React.Fragment>
      <div className="page-content">
        <Container fluid className="" >
          <div className='row'>
            Descargando excel....
          </div>
        </Container>
      </div>  
    </React.Fragment>
  )
}